import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useSendTransaction } from '@privy-io/react-auth';

import { useAccount, usePublicClient, useWalletClient } from 'shared/hooks/use-web3';
import { usePlayerGamesStore } from 'shared/store/playerGamesStore';
import { useRoomStore } from 'shared/store/roomStore';
import { isMocked } from 'shared/utils/isMocked';

export const useReveal = () => {
  const { playMoves } = usePlayerGamesStore();

  const { activeRoomId } = useParams();
  const { address, chainId, isPrivyWallet } = useAccount();
  const { roundCounter } = useRoomStore();

  const revealKey = useMemo(() => {
    return activeRoomId + address + chainId + roundCounter;
  }, [activeRoomId, address, chainId, roundCounter]);
  const { revealMoveAction } = useRoomStore();
  const publicClient = usePublicClient();

  const walletClient = useWalletClient();

  const { sendTransaction } = useSendTransaction();

  const writeReveal = useCallback(async () => {
    await revealMoveAction({
      roomId: BigInt(activeRoomId),
      roundCounter,
      move: playMoves?.[revealKey]?.move,
      salt: playMoves?.[revealKey]?.salt,
      walletClient,
      publicClient,
      userAddress: address,
      isPrivyWallet,
      sendTransaction,
    });
  }, [
    revealMoveAction,
    activeRoomId,
    roundCounter,
    playMoves,
    revealKey,
    walletClient,
    publicClient,
    address,
    isPrivyWallet,
    sendTransaction,
  ]);

  if (isMocked) {
    return { writeReveal: async () => {} };
  }

  return { writeReveal };
};
